<template>
  <div class="ma-0 pa-0 card-container">
    <v-card flat class="card-container blue-grey lighten-5 pa-0 ma-0">
      <v-row class="row-container" align="center">
        <v-col class="d-flex flex-column align-center">
          <v-img
            src="@/assets/images/not-found.svg"
            width="270"
            height="160"
            class="image"
          ></v-img>
          <h2 class="text-center mt-2">
            {{ $t("textSorry") }}<br />
            {{ $t("pageNotFound") }}
          </h2>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "MicrositeError",
  data() {
    return {
      errorStatus: "",
      errorText: "",
    };
  },
  methods: {},
};
</script>


<style lang="scss" scoped>
.card-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.image {
  margin-top: 250px;
}
</style>
